import type { ComboBoxInputListModalCSSVars, ComboBoxInputDefinition } from './ComboBoxInput'
import { getCrossEditorsCssVars } from './common'
import { withCompInfo } from '@wix/editor-elements-integrations'

const justifyContent = {
	left: 'flex-start',
	center: 'center',
	right: 'flex-end',
} as const

export const css = withCompInfo<ComboBoxInputListModalCSSVars, ComboBoxInputDefinition>()(
	[
		'compProps',
		'hasResponsiveLayout',
		'compLayout',
		'styleProperties',
		'siteFonts',
		'isMobileView',
		// @ts-ignore - remove once isOneDocMigrated is added to CompInfo
		'isOneDocMigrated',
	],
	// @ts-ignore - remove once isOneDocMigrated is added to CompInfo
	({ compProps, hasResponsiveLayout, compLayout, styleProperties, siteFonts, isMobileView, isOneDocMigrated }) => {
		const { textAlignment, dropdownItemsSpacing } = compProps
		const dropdownOptionJustifyContent = justifyContent[textAlignment!] || 'flex-start'
		const compInfo = { compLayout, styleProperties, siteFonts, isMobileView }

		return {
			height: '100%',
			'--dropdownItemsSpacing': `${typeof dropdownItemsSpacing === 'number' ? dropdownItemsSpacing : 16}px`,
			'--dropdownOptionJustifyContent': dropdownOptionJustifyContent,
			...getCrossEditorsCssVars(compInfo, compProps, isOneDocMigrated),
			...(!hasResponsiveLayout && { width: 'initial' }),
		}
	}
)
